import { array, func, string, bool } from "prop-types";

import { useState } from "react";

const propTypes = {
  sorters: array,
  showSortByLabel: string,
  onFacetClick: func,
  matchesLarge: bool,
};

const Sorter = (props) => {
  const { sorters, showSortByLabel, onFacetClick, matchesLarge } = props;

  const [activeSorter, setActiveSorter] = useState(() => {
    // Note that this logic only works on initial page load;
    // isActive is not reassigned each time a new option is clicked.
    let initialActive = sorters.find((facet) => facet.isActive === true);
    return initialActive?.value;
  });

  return (
    <>
      <div className="facet__group">
        {!matchesLarge && <div className="facet__label">{showSortByLabel}</div>}
        <ul className="facet__sorters facet__value-list">
          {sorters.map((sorter) => {
            return (
              <li className="facet__value" key={sorter.id}>
                <label className="facet__value--radio">
                  <input
                    type="radio"
                    id={sorter.id}
                    value={sorter.value}
                    name={sorter.value}
                    onChange={() => {
                      onFacetClick("sortBy", sorter.value);
                      setActiveSorter(sorter.value);
                    }}
                    checked={activeSorter === sorter.value}
                  />
                  <span className="facet__custom-radio-btn"></span>

                  <span>{sorter.label}</span>
                </label>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

Sorter.propTypes = propTypes;
export default Sorter;
